import { apiSlice } from '@/store/api/apiSlice';
import { getTransitTimestamp } from '@/utils/getTransitTimestamp';

export interface PlanetaryTransitItem {
  sign: string;
  planet: string;
  degree: string;
  nakshatra: string;
  pada: number;
  awastha: string;
  retro: boolean;
}

export interface PlanetaryTransitResponse {
  date: string;
  transit: PlanetaryTransitItem[];
}

export const monthlyPlanetaryTransitApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMonthlyPlanetaryTransit: builder.query<
      PlanetaryTransitResponse,
      {
        monthType?: 'current' | 'next';
        timestamp: string;
      }
    >({
      query: ({ timestamp }) => ({
        url: '/transits/general-planetry-transit',
        method: 'GET',
        params: { timestamp },
      }),
    }),
  }),
});

export const { useGetMonthlyPlanetaryTransitQuery } =
  monthlyPlanetaryTransitApi;
